/* eslint-disable no-process-env */
/* global localStorage */

import React from 'react';
import {render} from 'react-dom';
import {applyMiddleware, createStore} from 'redux';
import {Provider} from 'react-redux';
import {ApolloClient} from 'apollo-client';
import {setContext} from 'apollo-link-context';
import {createHttpLink} from 'apollo-link-http';
import {InMemoryCache} from 'apollo-cache-inmemory';
import {ApolloProvider} from 'react-apollo';
import thunkMiddleware from 'redux-thunk';
import throttle from 'lodash/throttle';
import 'typeface-roboto';
import App from './de/ergovia/components/App';
import reducer from './de/ergovia/reducers/reducer';
import matomoTracker from './de/ergovia/middleware/matomoTracker';
import { loadState, saveState } from './de/ergovia/localStorage';


const httpLink = createHttpLink({
    uri: process.env.BILDUNGSMANAGER_API_URL
});

const authLink = setContext((_, {headers}) => ({
    headers: {
        ...headers,
        'X-JWT': localStorage.getItem('token')
    }
}));

const trackingEnabled = process.env.BILDUNGSMANAGER_MATOMO_TRACKING_ENABLED === 'true';

const appliedMiddleware = trackingEnabled ? applyMiddleware(thunkMiddleware, matomoTracker) :
    applyMiddleware(thunkMiddleware);

const persistedState = loadState();

const store = createStore(reducer, persistedState, appliedMiddleware),
    client = new ApolloClient({
        link: authLink.concat(httpLink),
        cache: new InMemoryCache()
    });

// Throttle verhindert, dass die teure JSON.stringify-Methode in saveState nicht häufiger als 1 mal pro Sekunde ausgeführt wird
store.subscribe(throttle(() => {
    saveState({
        sort: store.getState().sort,
        filter: store.getState().filter
    });
}), 1000);

render(
    <ApolloProvider client={client}>
        <Provider store={store}>
            <App trackingEnabled={trackingEnabled}/>
        </Provider>
    </ApolloProvider>,
    document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js